export default {
  name: "CheckSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m27.19 9.58-11.2 14.67a1.5 1.5 0 0 1-2.15.24l-8.8-7.33a1.5 1.5 0 0 1-.19-2.11 1.5 1.5 0 0 1 2.11-.19l7.6 6.33L24.81 7.76c.5-.66 1.44-.79 2.1-.28.66.5.79 1.44.28 2.1z",
  },
}
